import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../services/baseQuery';
import type { ApiResponse } from '../../menu/types';
import { toCamelCase } from '../utils';
import { extractErrorMessage } from '../../../utils/errorUtils';

export type InvoiceCompanyBankOptionsRequest = {
  invoiceIds: number[];
};

export type CompanyBankAccountOption = {
  crmRelationFinanceId: number;
  bankName: string;
  iban: string;
  swiftCode: string;
  currencyName: string;
  isDefault: boolean;
  isCurrent: boolean;
  displayName: string;
};

export type InvoiceCompanyBankOptions = {
  companyName: string;
  currencyName: string;
  invoiceCount: number;
  bankAccounts: CompanyBankAccountOption[];
  currentAccountLabel: string;
  hasMixedCurrentAccounts: boolean;
};

export const companyBankAccountApi = createApi({
  reducerPath: 'companyBankAccountApi',
  baseQuery,
  endpoints: (builder) => ({
    getInvoiceCompanyBankOptions: builder.mutation<
      InvoiceCompanyBankOptions,
      InvoiceCompanyBankOptionsRequest
    >({
      query: (request) => ({
        url: '/umbraco/api/InvoiceCompanyBank/GetBankAccountOptions',
        method: 'POST',
        body: request,
      }),
      transformResponse: (response: ApiResponse<InvoiceCompanyBankOptions>) => {
        if ((response.Code ?? response.code) === 1) {
          return toCamelCase(response.data) as InvoiceCompanyBankOptions;
        }
        throw new Error(extractErrorMessage(response, 'Failed to load bank account options.'));
      },
    }),
  }),
});

export const { useGetInvoiceCompanyBankOptionsMutation } = companyBankAccountApi;
